import { forwardRef } from 'react'
import styles from './Actions.module.css'

// Adapted from BoardUI 0.5.9 button/button-link/icon-button source, retrieved
// through its MCP. Keep its native elements and label slot, with Studio's
// token roles, sizing and child icons instead of BoardUI globals/Remix icons.
const buttonClasses = (variant, size, className) => [
  styles.button, styles[variant], styles[size], className,
].filter(Boolean).join(' ')

export const BoardButton = forwardRef(function BoardButton({
  variant = 'primary', size = 'default', className = '', type = 'button',
  leading, children, ...props
}, ref) {
  return (
    <button {...props} ref={ref} type={type} className={buttonClasses(variant, size, className)}>
      {leading}
      <span className={styles.label}>{children}</span>
    </button>
  )
})

export const BoardButtonLink = forwardRef(function BoardButtonLink({
  variant = 'primary', size = 'default', className = '', children, ...props
}, ref) {
  return (
    <a {...props} ref={ref} className={buttonClasses(variant, size, className)}>
      <span className={styles.label}>{children}</span>
    </a>
  )
})

export const BoardIconButton = forwardRef(function BoardIconButton({
  variant = 'secondary', className = '', type = 'button', children, ...props
}, ref) {
  return (
    <button {...props} ref={ref} type={type} className={[
      styles.iconButton,
      variant === 'ghost' ? styles.iconButtonGhost : '',
      variant === 'danger' ? styles.iconButtonDanger : '',
      className,
    ].filter(Boolean).join(' ')}>
      {children}
    </button>
  )
})

export function ButtonPendingGlyph() {
  return <span className={styles.spinner} aria-hidden="true" />
}

export function PendingButtonLabel({ children }) {
  return <span className={styles.loadingContent}>{children}</span>
}
